'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.BackgroundPanelContent = exports.FullHightDiv = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _templateObject = _taggedTemplateLiteral(['\n  height: 100%;\n'], ['\n  height: 100%;\n']),
    _templateObject2 = _taggedTemplateLiteral(['\n  border-radius: 8px 8px 0 0;\n  height: ', 'px;\n  border-bottom: 1px solid ', ';\n  &.mobile,\n  &.inline {\n    border-radius: 0;\n  }\n'], ['\n  border-radius: 8px 8px 0 0;\n  height: ', 'px;\n  border-bottom: 1px solid ', ';\n  &.mobile,\n  &.inline {\n    border-radius: 0;\n  }\n']);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _classNames = require('react-utils/classNames');

var _classNames2 = _interopRequireDefault(_classNames);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _colors = require('HubStyleTokens/colors');

var _RecordPropType = require('ui-addon-conversations/prop-types/RecordPropType');

var _RecordPropType2 = _interopRequireDefault(_RecordPropType);

var _dimensions = require('ui-addon-conversations/widget-dimensions/constants/dimensions');

var _color = require('../visitor-widget/util/color');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var FullHightDiv = exports.FullHightDiv = _styledComponents2.default.div.withConfig({
  displayName: 'WidgetHeaderStyleWrapper__FullHightDiv'
})(_templateObject);

var BackgroundPanelContent = exports.BackgroundPanelContent = _styledComponents2.default.div.withConfig({
  displayName: 'WidgetHeaderStyleWrapper__BackgroundPanelContent'
})(_templateObject2, _dimensions.HEADER_HEIGHT, _colors.KOALA);

var WidgetHeaderStyleWrapper = function (_React$Component) {
  _inherits(WidgetHeaderStyleWrapper, _React$Component);

  function WidgetHeaderStyleWrapper() {
    _classCallCheck(this, WidgetHeaderStyleWrapper);

    return _possibleConstructorReturn(this, (WidgetHeaderStyleWrapper.__proto__ || Object.getPrototypeOf(WidgetHeaderStyleWrapper)).apply(this, arguments));
  }

  _createClass(WidgetHeaderStyleWrapper, [{
    key: 'render',
    value: function render() {
      var _props$coloring = this.props.coloring,
          accentColor = _props$coloring.accentColor,
          textColor = _props$coloring.textColor;
      var _props = this.props,
          inline = _props.inline,
          mobile = _props.mobile;

      var _getBrandClassNameAnd = (0, _color.getBrandClassNameAndStyle)(accentColor),
          headerBrandingClassName = _getBrandClassNameAnd.className,
          headerBrandingStyles = _getBrandClassNameAnd.style;

      var backgroundPanelClassNames = (0, _classNames2.default)('widget-background-panel', headerBrandingClassName, {
        mobile: mobile,
        inline: inline
      });
      return _react2.default.createElement(
        BackgroundPanelContent,
        {
          className: backgroundPanelClassNames,
          style: headerBrandingStyles
        },
        _react2.default.createElement(
          FullHightDiv,
          { style: { color: textColor } },
          _react2.default.createElement(
            FullHightDiv,
            { className: 'display-flex p-y-4 align-center' },
            this.props.children
          )
        )
      );
    }
  }]);

  return WidgetHeaderStyleWrapper;
}(_react2.default.Component);

WidgetHeaderStyleWrapper.propTypes = {
  children: _react.PropTypes.node,
  coloring: (0, _RecordPropType2.default)('ColoringRecord').isRequired,
  inline: _react.PropTypes.bool.isRequired,
  mobile: _react.PropTypes.bool
};

exports.default = WidgetHeaderStyleWrapper;